import { useState, useRef, useEffect } from "react";
import "./registerDetailsComp.css"; // Import the CSS file

import { useReactToPrint } from "react-to-print";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import axios from "axios";
import Logo from "../test.png";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";

import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

let transactionsData;

export default function RegisterDetailsComp() {
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const { accessType } = useSelector((state) => state.clientFunction);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { registerData } = useSelector((state) => state.terminalActions);

  const { clientData, userInfo } = useSelector(
    (state) => state.clientFunction?.companiesDB,
  );

  async function apiGetSales() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/register/${registerData?.registerId}/client/${clientData?.clientId}/getRegSoldItem`,
      )
      .then((response) => {
        transactionsData = response.data.regTransactions;
        console.log("REGIOSTER: ", response?.status || "REQUEST_FINISHED");
        if (response.data.status === 201) {
          setLoading(false);
        } else {
          enqueueSnackbar(`${response.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        enqueueSnackbar(`error: something went wrong!`, {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
        console.log(error?.code || "REQUEST_FAILED");
        setLoading(false);
      });
  }

  // SUMMATION OF THE ENTIRE TRANSACTIONS FUCTIONS
  function getSalesSummary(transactionsData = []) {
    const paymentMethods = [
      "cash",
      "credit",
      "debit",
      "gift",
      "account",
      "check",
      "multiple-pay",
    ];

    const summary = {
      totalItemsSold: 0,
      totalPaymentsMade: 0,
      totalDebts: 0,
      paymentMethods: {},
    };

    paymentMethods.forEach((method) => {
      summary.paymentMethods[method] = {
        transactions: 0,
        amount: 0,
      };
    });

    transactionsData.forEach((transaction) => {
      summary.totalItemsSold +=
        transaction.soldItems?.reduce(
          (total, item) => total + Number(item.soldQuantity || 0),
          0,
        ) || 0;

      const amount = Number(transaction.totals?.subtotal || 0);
      const method = transaction.payment?.method?.toLowerCase();

      if (summary.paymentMethods[method]) {
        summary.paymentMethods[method].transactions++;
        summary.paymentMethods[method].amount += amount;
      }

      if (method === "credit") {
        summary.totalDebts += amount;
      } else {
        summary.totalPaymentsMade += amount;
      }
    });

    return summary;
  }
  // Call it using your array
  const salesSummary = getSalesSummary(transactionsData);

  // SESSION FUNCTIONS

  const diffMs = Date.now() - new Date(registerData?.timeInn).getTime();

  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  const sessionTime = `${hours}h ${minutes}m`;

  const sessionStart = new Date(registerData?.timeInn);
  const from = sessionStart.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });

  const to = new Date().toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });

  const theSession = `${from} - ${to}`;
  useEffect(() => {
    apiGetSales();
  }, [registerData?.registerId, clientData?.clientId]);

  return (
    <div
      id="registerDetailTransactions"
      className="registerDetailWrapper fx-cl space3"
      onClick={(e) => e.stopPropagation()}
      ref={contentRef}
    >
      <button
        id="registerPrint"
        className="btnPrintRcpt"
        onClick={() => reactToPrintFn()}
        style={{ backgroundColor: "transparent", color: "#062e6f" }}
      >
        <LocalPrintshopIcon style={{ fontSize: "3.2rem" }} />
      </button>
      <div className="registerDetail flex-container">
        {/* First Container */}
        <div className="registerDetail-first-container">
          <div className="payments-left-side fx-ac space2">
            <figure className="paymentsLogo">
              <AssuredWorkloadIcon style={{ fontSize: "4.7rem" }} />
            </figure>
            <div className="fx-cl space1">
              <h1>Payments</h1>

              <p>Respresentive: {registerData?.representiveName}</p>
            </div>
          </div>
          <div className="payments-right-side fx-cl space1">
            <p>{registerData?.location?.name} </p>
            <p>{registerData?.location?.address}</p>
          </div>
        </div>

        {/* Second Container */}
        <div className="registerDetail-second-container fx-jb space3">
          <div className="registerDetail-inner-div">
            <div className=" fx-cl space1">
              <h3>Operation Details</h3>
              <div className="fx-cl spacem">
                <p>
                  <strong>Register Reference ID: </strong>
                  {registerData?.registerId}
                </p>
                <p>
                  <strong>Items sold: </strong>
                  {salesSummary.totalItemsSold}
                </p>
                <p>
                  <strong>Total payments: </strong> ₦
                  {salesSummary.totalPaymentsMade.toLocaleString()}
                </p>
                <p>
                  <strong>Debts: </strong> ₦
                  {salesSummary.totalDebts.toLocaleString()}
                </p>
                <p>
                  <strong>Session: </strong>
                  {theSession}
                </p>
                <p>
                  <strong>Hours: </strong> {sessionTime}
                </p>
              </div>
            </div>
          </div>
          <div className="registerDetail-inner-div">
            <div className=" fx-cl space1">
              <h3>User info:</h3>
              <div className="fx-cl spacem">
                <p>
                  <strong>Staff ID: </strong> {registerData?.representiveId}
                </p>
                <p>
                  <strong>Username: </strong>
                  {registerData?.representiveUserName}
                </p>

                <p>
                  <strong>Location: </strong>{" "}
                  {registerData?.inventory?.inventoryName}
                </p>
                <p>
                  <strong>Phone No.: </strong>{" "}
                  {registerData?.representiveNumber}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Third Container */}
        <div className="registerDetail-third-container fx-cl space3">
          <div className="fx-cl">
            <h3>Payment details</h3>
            <p>Overview of payments and outstanding balances</p>
          </div>
          <table className="registerDetailTable">
            <thead style={{ textAlign: "left" }}>
              <tr>
                <th>Serial No.</th>
                <th>Items</th>
                <th>Discription</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4">
                  <h2>Earning</h2>
                </td>
              </tr>

              <tr>
                <td>01</td>
                <td>Total Items Sold</td>
                <td>All sold inventory items</td>
                <td>{salesSummary.totalItemsSold}</td>
              </tr>

              <tr>
                <td>02</td>
                <td>Total Payments</td>
                <td>Paid transactions excluding credit</td>
                <td>₦{salesSummary.totalPaymentsMade.toLocaleString()}</td>
              </tr>

              <tr>
                <td>03</td>
                <td>Total Debts</td>
                <td>Credit transactions</td>
                <td>₦{salesSummary.totalDebts.toLocaleString()}</td>
              </tr>

              <tr>
                <td colSpan="4">
                  <h2>Payment Methods</h2>
                </td>
              </tr>

              {Object.entries(salesSummary.paymentMethods).map(
                ([method, data], index) => (
                  <tr key={method}>
                    <td>{String(index + 1).padStart(2, "0")}</td>
                    <td>
                      {method.replace(/\b\w/g, (char) => char.toUpperCase())}
                    </td>
                    <td>{data.transactions} transaction(s)</td>
                    <td>₦{data.amount.toLocaleString()}</td>
                  </tr>
                ),
              )}

              <tr>
                <td></td>
                <td>
                  <strong>TOTAL</strong>
                </td>
                <td>-</td>
                <td>
                  <strong>
                    ₦{salesSummary.totalPaymentsMade.toLocaleString()}
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="baseDetails fx-jb space6">
            <div className="buttomLeftDetails fx-cl space1">
              <span>
                <strong>Payment Summary</strong>
              </span>

              <div className="fx-cl space">
                <span>
                  Cash Payments:{" "}
                  <strong>
                    ₦{salesSummary.paymentMethods.cash.amount.toLocaleString()}
                  </strong>
                </span>

                <span>
                  Bank Transfer:{" "}
                  <strong>
                    ₦
                    {salesSummary.paymentMethods.account.amount.toLocaleString()}
                  </strong>
                </span>

                <span>
                  Card Payments:{" "}
                  <strong>
                    ₦{salesSummary.paymentMethods.debit.amount.toLocaleString()}
                  </strong>
                </span>

                <span>
                  POS Terminal: <strong>₦0</strong>
                </span>

                <span>
                  Mobile Money: <strong>₦0</strong>
                </span>

                <span>
                  Credit Sales:{" "}
                  <strong>
                    ₦
                    {salesSummary.paymentMethods.credit.amount.toLocaleString()}
                  </strong>
                </span>
              </div>

              <div className="fx-cl spacem">
                <span>
                  <strong>Register Status</strong>
                </span>

                <span>
                  Opening Balance:{" "}
                  <strong>
                    ₦{(registerData?.openingBalance || 0).toLocaleString()}
                  </strong>
                </span>

                <span>
                  Cash Received:{" "}
                  <strong>
                    ₦{salesSummary.paymentMethods.cash.amount.toLocaleString()}
                  </strong>
                </span>

                <span>
                  Expected Cash:{" "}
                  <strong>
                    ₦
                    {(
                      (registerData?.openingBalance || 0) +
                      salesSummary.paymentMethods.cash.amount
                    ).toLocaleString()}
                  </strong>
                </span>

                <span>
                  Cash Difference:{" "}
                  <strong>
                    ₦{(registerData?.cashDifference || 0).toLocaleString()}
                  </strong>
                </span>
              </div>
            </div>

            <div className="fx-cl fx-ac fx-jc space1">
              <div className="fx-cl space1">
                <div className="g g2 space2">
                  <span>
                    <strong>Subtotal:</strong>
                  </span>
                  <span>
                    <strong>
                      ₦{salesSummary.totalPaymentsMade.toLocaleString()}
                    </strong>
                  </span>
                </div>

                <div className="g g2 space2">
                  <span>Tax VAT: 0%</span>
                  <span>0 NGN</span>
                </div>

                <div className="g g2 space2">
                  <span>Discount: </span>
                  <span>₦5,764</span>
                </div>
              </div>

              <div className="grandToltalPreviewSales g g2">
                <span>
                  <strong>Grand Total:</strong>
                </span>
                <span>
                  <strong>
                    {" "}
                    ₦{salesSummary.totalPaymentsMade.toLocaleString()}
                  </strong>
                </span>
              </div>

              <div className="fx-cl fx-ac fx-jc spacem">
                <span>Account Manager</span>
                <span>
                  <strong>
                    {registerData?.inventory?.manager.firstName}{" "}
                    {registerData?.inventory?.manager.lastName}
                  </strong>
                </span>
                <span>{/* <img src="" alt="signature" /> */}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
